import { render, staticRenderFns } from "./RedemptionList.vue?vue&type=template&id=74c10d3f&scoped=true"
import script from "./RedemptionList.vue?vue&type=script&lang=js"
export * from "./RedemptionList.vue?vue&type=script&lang=js"
import style0 from "./RedemptionList.vue?vue&type=style&index=0&id=74c10d3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c10d3f",
  null
  
)

export default component.exports